import { render, staticRenderFns } from "./UIRadioButton.vue?vue&type=template&id=684a2187&scoped=true"
import script from "./UIRadioButton.vue?vue&type=script&lang=js"
export * from "./UIRadioButton.vue?vue&type=script&lang=js"
import style0 from "./UIRadioButton.vue?vue&type=style&index=0&id=684a2187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a2187",
  null
  
)

export default component.exports